import React from "react";
import { ArrowLeft, Utensils } from "lucide-react";
import StepCard from "./StepCard";
import FinalCard from "./FinalCard";
import { useStepsCarousel } from "./useStepsCarousel";

const StepsCarousel = ({
    steps,
    recipe,
    servings,
    showIngredients,
    setShowIngredients,
    onShowFeedback
}) => {
    const totalItems = (steps?.length || 0) + 1;
    const {
        carouselRef,
        activeCardIndex,
        scrollToCard,
        handleNext,
        handlePrev
    } = useStepsCarousel(totalItems);

    return (
        <div className="flex-grow-1 position-relative d-flex flex-column pb-5">
            <div className="d-flex align-items-center justify-content-between mb-3 container-fluid px-0" style={{ maxWidth: '1200px', margin: '0 auto' }}>
                <div className="d-flex align-items-center gap-3">
                    <h4 className="fw-bold font-serif m-0">Zubereitung</h4>
                    <button
                        className={`btn rounded-pill px-3 d-flex align-items-center gap-2 fw-medium border shadow-sm ${showIngredients ? 'btn-primary text-white' : 'btn-light text-dark'}`}
                        onClick={() => setShowIngredients(!showIngredients)}
                    >
                        <Utensils size={18} /> <span className="d-none d-md-inline">Zutaten</span>
                    </button>
                </div>
                {/* Navigation Buttons */}
                <div className="d-flex gap-2">
                    <button
                        className={`btn btn-light rounded-circle shadow-sm border d-flex align-items-center justify-content-center ${activeCardIndex === 0 ? 'disabled opacity-50' : ''}`}
                        style={{ width: '40px', height: '40px' }}
                        onClick={handlePrev}
                        disabled={activeCardIndex === 0}
                    >
                        <ArrowLeft size={20} />
                    </button>
                    <button
                        className={`btn btn-light rounded-circle shadow-sm border d-flex align-items-center justify-content-center ${activeCardIndex === totalItems - 1 ? 'disabled opacity-50' : ''}`}
                        style={{ width: '40px', height: '40px' }}
                        onClick={handleNext}
                        disabled={activeCardIndex === totalItems - 1}
                    >
                        <div style={{ transform: 'rotate(180deg)' }}><ArrowLeft size={20} /></div>
                    </button>
                </div>
            </div>

            <style>
                {`
                .no-scrollbar::-webkit-scrollbar {
                    display: none;
                }
                .no-scrollbar {
                    -ms-overflow-style: none;
                    scrollbar-width: none;
                }
            `}
            </style>

            <div
                className="overflow-x-auto px-4 no-scrollbar"
                ref={carouselRef}
                style={{
                    display: 'grid',
                    gridAutoFlow: 'column',
                    gridAutoColumns: '400px',
                    gap: '1.5rem',
                    alignItems: 'stretch',
                    scrollSnapType: 'x mandatory',
                    paddingLeft: 'max(24px, calc(50% - 600px))',
                    paddingRight: 'max(24px, calc(50% - 600px))',
                    paddingTop: '2rem',
                    paddingBottom: '2rem'
                }}
            >
                {steps.map((step, idx) => (
                    <StepCard
                        key={step.id || idx}
                        step={step}
                        index={idx}
                        recipe={recipe}
                        servings={servings}
                        isActive={activeCardIndex === idx}
                        onClick={() => scrollToCard(idx)}
                    />
                ))}

                <FinalCard
                    isActive={activeCardIndex === totalItems - 1}
                    onClick={() => scrollToCard(totalItems - 1)}
                    onShowFeedback={onShowFeedback}
                />
            </div>
        </div>
    );
};

export default StepsCarousel;
